<h2 mat-dialog-title>Confirmation</h2>
<button mat-icon-button class="close-button" (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>
<mat-dialog-content>
  <p>{{ data.message }}</p>
  <div *ngIf="data.prompt">
    <strong>Prompt:</strong> {{ data.prompt }}
  </div>
<div *ngIf="data.fileName">
    <strong>File:</strong> {{ data.fileName }}
</div>
<div *ngIf="data.serialStart">
    <strong>Serial Start:</strong> {{ data.serialStart }}
</div>
<div *ngIf="data.serialEnd">
    <strong>Serial End:</strong> {{ data.serialEnd }}
</div>
</mat-dialog-content>
<mat-dialog-actions>
  <button type="button" class="discard-button" (click)="onCancel()">
    <mat-icon>close</mat-icon>
    CANCEL
  </button>
  <button type="button" class="confirm-button" (click)="onConfirm()">
    <mat-icon>check</mat-icon>
    CONFIRM
  </button>
</mat-dialog-actions>
